import { EnvironmentStateSlice } from './models';

export const selectAuthenticationMethod = (state: EnvironmentStateSlice) => state.environment.authenticationMethod;
export const selectApiUrl = (state: EnvironmentStateSlice) => state.environment.apiUrl;
